import React from 'react'
import { Box, Typography, Button, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'

function General(props) {
 
  const [configPath, setConfigPath] = React.useState('rma/general/');
  const [returnMaxDays, setReturnMaxDays] = React.useState('');
  const [returnStoreAddress, setReturnStoreAddress] = React.useState('');
  const [returnAutoCloseDays, setReturnAutoCloseDays] = React.useState('');
  const [returnShippingCarriers, setReturnShippingCarriers] = React.useState('');
  const [changedData, setChangedData] = React.useState([]);
  const [alertText, setAlertText] = React.useState('')
  const [openAlert, setOpenAlert] = React.useState(false)
  const payloadData = [];
  // const changedData = [];

  React.useEffect(() => {
    axios.get(`${legolasApi.url}/admin/config/get/all`).then((res) => {
      console.log("Order data",res.data);
      if (res.data.success) {
        res.data.data.map((singleConfig) => {
          switch(singleConfig.path) {
            case 'rma/general/return_max_days':
              setReturnMaxDays(singleConfig.value);
              break;
            case 'rma/general/return_store_address':
              setReturnStoreAddress(singleConfig.value);
              break;
            case 'rma/general/return_auto_close_in_days':
              setReturnAutoCloseDays(singleConfig.value);
              break;
            case 'rma/general/return_shipping_carriers':
              setReturnShippingCarriers(singleConfig.value);
              break;
            default:
              break;
          }

        });
      }
    })
  }, [])

   
  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const handleConfigChange = (key, value) => {

    let returnMaxdaysData = {
      key:'return_max_days',
      value: returnMaxDays
    }
    let returnStoreAddressData = {
      key:'return_store_address',
      value: returnStoreAddress
    }
    let returnAutoCloseDaysData = {
      key:'return_auto_close_in_days',
      value: returnAutoCloseDays
    }
    let returnShippingCarriersData = {
      key:'return_shipping_carriers',
      value: returnShippingCarriers
    }
    // changedData.push(pair);
    
    switch(key) {
      case 'return_max_days':
        setReturnMaxDays(value);
        returnMaxdaysData = {
          key:'return_max_days',
          value: value
        }
        break;
      case 'return_store_address':
        setReturnStoreAddress(value);
        returnStoreAddressData = {
          key:'return_store_address',
          value: value
        }
        break;
      case 'return_auto_close_in_days':
        setReturnAutoCloseDays(value);
        returnAutoCloseDaysData = {
          key:'return_auto_close_in_days',
          value: value
        }
        break;
      case 'return_shipping_carriers':
        setReturnShippingCarriers(value);
        returnShippingCarriersData = {
          key:'return_shipping_carriers',
          value: value
        }
        break;
      default:
        break;
    }
    setChangedData([returnMaxdaysData, returnStoreAddressData, returnAutoCloseDaysData, returnShippingCarriersData])
    // console.log("changedData: ",changedData);
  }

  
  function handleSubmitConfig() {
    // console.log("calling handleSubmitConfig", changedData);
    changedData.map((data) => {
      // console.log("final data",data);
      let record = {
        scope: 'default',
        scope_id: 0,
        path: configPath + data.key,
        value: data.value
      }
      payloadData.push(record);
    });
    axios.post(`${legolasApi.url}/admin/config/add`, payloadData).then((res) => {
      // console.log('Save config res: ', res)
      const data = res.data
      if (data.success) {
        handleAlertGen(data.message)
      }
    }).catch((error) => {
      console.log('Error in submit res: ', error)
    })
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }
 
  return (
    <React.Fragment>
      <Box id='accountinfo-box'>

      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
        <Box sx={{ width: '102%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
           General
          </Typography>
        </Box>
      
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { m: -1.5,    width: '355px','padding-right': '0.5rem' },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={lightBox} >
            <Typography> Return Max Days</Typography>
            <Typography>
              <input type="text"
                  name="return_max_days"
                  value={returnMaxDays}
                  onChange={(e) => handleConfigChange('return_max_days', e.target.value)} 
                  style={{height: '2rem',width:'344px'}}/>
            </Typography>
          </Box>
                  
          <Box sx={lightBox} >
            <Typography>Store Address For Returns</Typography>
            <Typography  >
              <input type="text"
                  name="return_store_address"
                  value={returnStoreAddress}
                  onChange={(e) => handleConfigChange('return_store_address', e.target.value)} 
                  style={{height: '2rem',width:'344px'}}/>
                  
            </Typography>
          </Box>
          <Box sx={lightBox} >
            <Typography> RMA Auto-Closes In (days)</Typography>
            <Typography  >
              <input type="text"
                  name="return_auto_close"
                  value={returnAutoCloseDays}
                  onChange={(e) => handleConfigChange('return_auto_close_in_days', e.target.value)}
                  style={{height: '2rem',width:'344px'}}/>
            </Typography>
          </Box>
                  
          <Box sx={lightBox} >
            <Typography>Shipping Carriers For Returns</Typography>
            <Typography >
              <input type="text"
                  name="return_shipping_carriers"
                  value={returnShippingCarriers}
                  onChange={(e) => handleConfigChange('return_shipping_carriers', e.target.value)}
                  style={{height: '2rem',width:'344px'}}/>
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey, margin: '15px 0px' }}>
         <Button sx={globalStyles.reusableButton} onClick={() => handleSubmitConfig()}>       Save  
         </Button>
      </Box>
    </React.Fragment>
  )
}
 export default General